// import html5 from "../../assets/htm5.png";

import html5 from "../assets/html5.png";
import css3 from "../assets/css3.png";
import bootstrap from "../assets/bootstrap.png";
import javascript from "../assets/javascript.png";
import jquery from "../assets/jquery.png";
import java from "../assets/java.png";
import spring from "../assets/spring.png";
import python from "../assets/python.png";
import django from "../assets/django.png";
import reactimg from "../assets/reactimg.png";
import mysql from "../assets/mysql.png";
import postgresql from "../assets/postgresql.png";

const Technologies_list = [
  {
    img: html5,
    name: "HTML5",
  },
  {
    img: css3,
    name: "CSS3",
  },
  {
    img: bootstrap,
    name: "Bootstrap5",
  },
  {
    img: javascript,
    name: "Javascript",
  },
  {
    img: jquery,
    name: "Jquery",
  },
  {
    img: reactimg,
    name: "React",
  },
  {
    img: java,
    name: "JAVA",
  },
  {
    img: spring,
    name: "Sprint",
  },
  {
    img: python,
    name: "Python",
  },
  {
    img: django,
    name: "Django",
  },
  {
    img: mysql,
    name: "mysql",
  },
  {
    img: postgresql,
    name: "postgresql",
  },
];

export default Technologies_list;
